import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de281153b1c854/node_modules/next/dist/client/link.js");
